export const rootCss = {
  marginTop: "1em",
  marginBottom: "1em",
};
